import { posterUrl } from '../api/tmdb'
import { IconTv, IconCheck } from './icons'

const POSTER_PH = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='342' height='513' viewBox='0 0 342 513'%3E%3Crect fill='%23333' width='342' height='513'/%3E%3Ctext fill='%23666' font-family='sans-serif' font-size='24' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo Poster%3C/text%3E%3C/svg%3E"

export default function FlipMovieCard({ movie, onExpand, isInChain = false }) {
  const handleActivate = (e) => {
    if (isInChain) return
    const rect = e.currentTarget.getBoundingClientRect()
    onExpand('movie', movie, rect)
  }

  return (
    <div
      className={[
        'grid-card grid-card--movie',
        movie.mediaType === 'tv' ? 'grid-card--tv' : '',
        isInChain ? 'grid-card--in-chain' : '',
      ].join(' ').trim()}
      onClick={handleActivate}
      role={isInChain ? undefined : 'button'}
      tabIndex={isInChain ? -1 : 0}
      onKeyDown={(e) => !isInChain && e.key === 'Enter' && handleActivate(e)}
      aria-label={
        isInChain
          ? `${movie.title} — already used`
          : `${movie.title} — tap to see cast`
      }
    >
      <img
        src={posterUrl(movie.poster_path) || POSTER_PH}
        alt={movie.title}
        className="grid-card__img"
        onError={(e) => { e.target.src = POSTER_PH }}
      />
      {movie.mediaType === 'tv' && (
        <span className="grid-card__tv-badge" aria-label="TV series"><IconTv size={12} style={{ verticalAlign: 'middle' }} /> TV</span>
      )}
      <div className="grid-card__footer">
        <span>{movie.title}</span>
        {isInChain && <span className="grid-card__chain-badge"><IconCheck size={12} style={{ verticalAlign: 'middle' }} /> Used</span>}
      </div>
    </div>
  )
}
